module.exports = __webpack_public_path__ + "static/media/Need Help Icon3.8ac8fa97.svg";